import React from 'react';
import { TopBar } from '@superops/ui-design-system';

export default function AppHeader() {
  return <TopBar />;
}
